<!--
展示作者是指定用户的菜单
@author 姚润发
@created 2021/04/13 17:38
-->
<template>
	<div style="display:flex; flex-direction: column; padding: 24px 0;">
		<div class="search-contain">
			<input class="search-input"
				   placeholder="请输入文档标题或作者关键字"
				   autocomplete="off"
				   type="text"
				   v-model="searchValue" @keyup.enter="searchObj.searchValue = searchValue">
			<button class="search-button" @click="searchObj.searchValue = searchValue">文档搜索</button>
		</div>
		<ul class="data-contain">
			<div v-show="showMenusList.length < 1">
				<link-icon icon="link-icon-zanwushuju" style="font-size: 80px"></link-icon>
				<span>暂无数据...</span>
			</div>
			<span v-show="showMenusList.length">文档列表</span>
			<li v-for="item in showMenusList" :key="item.id">
				<span class="title" @click="onClickMenu(item)">《{{item.title}}》</span>
				<span class="sub-title">
                ({{item.folder || '/'}})
                <i class="pointer"></i>
                {{item.author}}
                <i class="pointer"></i>
                {{item.pv ? item.pv : 1}}次浏览
            </span>
			</li>
		</ul>
	</div>
</template>

<script>
  import LinkIcon from "../../link-components/icon/link-icon";
  export default {
    name: "my-menu",
    components: {LinkIcon},
    inject: {
      DocumentPage: {default: null}
    },
	computed: {
      // 当前页面显示的文档
      showMenusList() {
        return this.allMenusList.filter(item => {
          return item.title.toLowerCase().indexOf(this.searchObj.searchValue.toLowerCase()) > -1
		  || item.author.toLowerCase().indexOf(this.searchObj.searchValue.toLowerCase()) > -1
		});
	  }
	},
    data() {
      const pageParam = this.pageParam || {};
      return {
        onlyMyDocFlag: pageParam.onlyMyDocFlag, // 只展示我的文档，用来区分首页或我的文档页面
		fstName: pageParam.fstName || this.$lv.$documentLogin.getFstName(),
        allMenusList: [], // 平铺开后的所有菜单
        pvList: [], // 文章的访问次数
        searchValue: '', // 搜索查询的条件
		searchObj: { // 搜索对象
          searchValue: '', // 搜索关键字
		  page: 1,
		  rows: 20,
		  total: 1
		} // 文档搜索对象
	  }
    },
    methods: {
      onClickMenu(menu) {
        this.DocumentPage.openById(menu.id, this)
      },
      /**
	   * 把菜单树的文档平铺展开放到数组里，作为当前页面的数据源
       */
	  genMenuList() {
        const obj = JSON.parse(JSON.stringify(this.DocumentPage.MENUS));

        const folderPath = [];
        const myDocList = [];
        // 过滤只显示当前登录用户的文档及目录
        const t = (obj) => {
          if (obj.children) {
            folderPath.push(obj);
            for (let i = 0; i<obj.children.length; i++) {
              let item = obj.children[i];
              if (!item.author) {
                item.author = '未知作者';
              }
              if (item.children) {
                // 还存在子对象
                t(item)
              } else if (this.onlyMyDocFlag && (!item.author || !item.author.split('/').includes(this.fstName))) {
                // 当前页面是我的文档页面时，不是我的文档，删除
                obj.children.splice(i, 1);
                i--;
              } else {
                // 我的文档，添加路径信息
                item.folder = folderPath.map(f => f.title).join('/');
                myDocList.push(item);
              }
            }
            folderPath.pop();
          }
        }
        t({children: obj, title: ''});

        this.allMenusList = myDocList;
	  },

      /**
	   * 设置文章访问次数到对应文档对象上
       */
	  setPv() {
        // 文章访问次数关联
        this.allMenusList.forEach(item => {
          const obj = this.pvList.find(pItem => pItem.id === item.id);
          if (obj) {
            this.$set(item, 'pv', obj.pv);
            // item.pv = obj.pv;
          }
        });
	  }
    },
	async created() {
      this.genMenuList()
      this.pvList = await this.$lv.$documentAccessService.getPvCount(this);
      this.setPv();
    }
  }
</script>

<style scoped lang="scss">
	$button-blue: #1F74FF;
	.search-contain{
		*{
			box-sizing: border-box;
		}
		text-align: center;
		min-width: 580px;
		.search-input{
			width: 480px;
			height: 40px;
			font-size: 14px;
			outline: none;
			border: 1px solid #E0E7FF;
			padding: 0 10px;
		}
		.search-button{
			width: 100px;
			height: 40px;
			font-size: 14px;
			background-color: $button-blue;
			border: 1px solid $button-blue;
			color: #FFFFFF;
			padding: 0;
			margin-left: -6px;
			right: 0;
			outline: none;
			cursor: pointer;
			&:active {
				opacity: 0.5;
			}
		}
	}
	.empty-text{
		font-size: 14px;
		line-height: 1;
		color: rgba(0,0,0,0.65);
	}
	ul{
		text-align: left;
		list-style: none;
		display: inline-block;
		position: relative;
		margin: 0 auto;
		padding: 24px;
		max-width: 100%;
		>span{
			font-size: 14px;
			color: #333333;
			text-align: left;
			line-height: 14px;
		}
		li{
			line-height: 14px;
			margin: 24px 0;
			max-width: 100%;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			&:before{
				content: '●'; //●•・∙
				// color: rgba(31,116,255,0.50);
				color: #1F74FF;
				opacity: .5;
				font-size: 6px;
				margin-right: 6px;
			}
			.title{
				vertical-align: middle;
				font-size: 14px;
				color: #333333;
				line-height: 14px;
				text-align: left;
				cursor: pointer;
				&:hover{
					color: #1F74FF;
				}
			}
			.sub-title{
				vertical-align: middle;
				font-size: 12px;
				color: #8798AD;
				line-height: 12px;
				.pointer {
					color: #151515;
					margin: 0 -3px;
					&:after{
						content: '・';
					}
				}
			}
		}
	}
</style>
